import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';
import { Card } from '@sorare/core/src/components/card/Card';
import { CardDescriptionFromProps } from '@sorare/core/src/components/token/CardDescriptionFromProps';
import { format } from '@sorare/core/src/lib/seasons';

import { Team } from '#src/components/Team/index.tsx';

import type { CommonCardSummary_commonPlayer } from './__generated__/index.graphql.ts';

const Image = styled.div`
  flex-shrink: 0;
  width: 52px;
`;

const Metas = styled.div`
  flex-grow: 1;
`;

type Props = {
  commonPlayer: CommonCardSummary_commonPlayer;
};

export const CommonCardSummary = ({ commonPlayer }: Props) => {
  return (
    <Vertical gap={2}>
      <Horizontal gap={1.5}>
        <Image>
          <Card card={commonPlayer} />
        </Image>
        <Metas>
          <CardDescriptionFromProps
            path={null}
            displayName={commonPlayer.anyPlayer.displayName}
            description={`${format(2024)} - Common`}
            withoutLink
            Title={BodyM}
            titleColor="var(--c-white)"
            Details={BodyS}
            detailsColor="var(--c-nd-600)"
          />
          <Team card={commonPlayer} />
        </Metas>
      </Horizontal>
    </Vertical>
  );
};

CommonCardSummary.fragments = {
  commonPlayer: gql`
    fragment CommonCardSummary_commonPlayer on CommonPlayer {
      id
      anyPlayer {
        slug
        displayName
        ...Team_anyPlayerInterface
      }
      ...Card_commonPlayer
    }
    ${Card.fragments.commonPlayer}
    ${Team.fragments.anyPlayerInterface}
  ` as TypedDocumentNode<CommonCardSummary_commonPlayer>,
};
